import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import classNames from 'classnames'
import * as analytics from 'lib/analytics'
import { highlightText } from 'lib/highlight-text'
import { setSearchFocused } from 'store/ui/actions'
import { selectMaybeDoi } from 'store/ui/selectors'
import styles from './styles/Dropdown.css'
import { setTab, TABS } from '../../store/home/actions'

const SearchLink = ({ children, iconClass = styles.linkIcon, ...rest }) => {
  const dispatch = useDispatch()

  return (
    <Link
      data-showdropdown
      data-dropdown-item
      className={styles.searchLink}
      onClick={() => dispatch(setSearchFocused(false))}
      {...rest}
    >
      <i className={iconClass} />
      <span className={styles.itemText}>{children}</span>
    </Link>
  )
}

export const Dropdown = ({ term, onClickResult, dropdownStyle, field, setDropdownOpen, showLinks = false, mode }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const autocompletes = useSelector(({ ui }) => ui.search.autocompletes)
  const maybeDoi = useSelector(({ ui }) => selectMaybeDoi(ui))
  const completions = autocompletes[field]
  const hasTerm = term && term.length >= 3

  if (!hasTerm || maybeDoi) {
    return null
  }

  const goTo = route => {
    return history.push(route)
  }

  return (
    <div className={classNames(styles.dropdown, dropdownStyle)}>
      {showLinks && (
        <>
          <SearchLink
            key='in-all'
            iconClass={styles.searchIcon}
            to={`/search?mode=all&q=${term}`}
            onMouseDown={() => goTo(`/search?mode=all&q=${term}`)}
          >
            Search <strong>{term}</strong>
          </SearchLink>
          {mode !== 'patents' && (
            <SearchLink
              key='in-authors'
              to={`/search?mode=all&author=${term}`}
              onMouseDown={() => goTo(`/search?mode=all&author=${term}`)}
            >
              Search <strong>{term}</strong> in authors
            </SearchLink>
          )}
          <SearchLink
            key='ask-question'
            iconClass={styles.questionIcon}
            to={`/assistant?startTerm=${term}`}
            onMouseDown={() => {
              dispatch(setTab(TABS.assistant))
              goTo('/assistant')
            }}
          >
            Query <strong>{term}</strong> using assistant
          </SearchLink>
        </>
      )}
      {completions &&
        completions.length > 0 &&
        completions.map((autocomplete, index) => (
          <div
            key={index}
            data-showdropdown
            data-dropdown-item
            tabIndex='0'
            className={styles.dropdownItem}
            onMouseDown={() => {
              analytics.event({
                category: 'Search',
                action: 'Clicked autocomplete result',
                label: autocomplete.completion
              })
              onClickResult(`"${autocomplete.completion}"`)
            }}
          >
            <i className={styles.searchIcon} />
            <span
              className={styles.itemText}
              dangerouslySetInnerHTML={{
                __html: highlightText(autocomplete.completion, term, {
                  startTag: `<span class="${styles.match}">`,
                  endTag: '</span>'
                })
              }}
            />
          </div>
        ))}
    </div>
  )
}

export default Dropdown
